import { Box, FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const DescripcionTareaAutoCoevaluacion = () => {
  const { setPromptData, promptData } = useActividadesContext();
  const descripcion_tareaValue = promptData?.descripcion_actividad ?? '';

  const handleIndicaciones = (event) => {
    const nuevaDescripcion = event.target.value;
    setPromptData((prevData) => ({
      ...prevData,
      descripcion_actividad: nuevaDescripcion
    }));
  };

  return (
    <Grid item xs={12} sx={{ mb: 3 }}>
      <Box>

        <Box sx={{ display: 'flex', flexDirection: 'row', }}>
          <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>
            Descripción de la actividad *
          </Typography>

        </Box>
        <Box>
          <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}>
            Describe detalladamente la actividad que será evaluada

          </FormLabel>
        </Box>

        <TextField
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          placeholder="Describe aquí el tipo de actividad que será evaluada. Por ejemplo:  “Línea de tiempo de la conquista española” y entrega los detalles necesarios para que ummIA generé los instrumentos."
          value={descripcion_tareaValue}
          onChange={handleIndicaciones}
          sx={{
            borderRadius: 2,
            fontFamily: 'montserrat',
            fontSize: '0.75rem',
            color: '#336B87',
            '& fieldset': { borderColor: '#Divider' },
            '&:before': { borderColor: '#Divider' },
            '&:after': { borderColor: '#Divider' }
          }}
          InputProps={{
            sx: {
              borderRadius: 2,
              fontFamily: 'montserrat',
              fontSize: '14px',
              color: '#336B87',

            }
          }}
        />
      </Box>
    </Grid>
  );
};

export default DescripcionTareaAutoCoevaluacion;
